
import {watchInitStudentBinder, sanitizeAssignmentData} from './studentBinderSagas';

const studentBinderSagas = [
  watchInitStudentBinder,
];

export {sanitizeAssignmentData};
export default studentBinderSagas;
